import { render, staticRenderFns } from "./status-form-contacts.vue?vue&type=template&id=1ca37a00&scoped=true"
import script from "./status-form-contacts.vue?vue&type=script&lang=js"
export * from "./status-form-contacts.vue?vue&type=script&lang=js"
import style0 from "./status-form-contacts.vue?vue&type=style&index=0&id=1ca37a00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca37a00",
  null
  
)

export default component.exports